import { render, staticRenderFns } from "./MyWalletGetGasSection.vue?vue&type=template&id=6acf73b5&scoped=true"
import script from "./MyWalletGetGasSection.vue?vue&type=script&lang=ts"
export * from "./MyWalletGetGasSection.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletGetGasSection.vue?vue&type=style&index=0&id=6acf73b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf73b5",
  null
  
)

export default component.exports